import * as React from 'react'
import { ColoredSpan, EllipsisSpan } from '../../../../common/src/components/core'
import { formatPhoneNumber } from '../../../../common/src/format'

interface ContactType {
  addressPhone?: string | null
  addressEmail?: string | null
  firstName?: string | null
  lastName?: string | null
}

export function ContactText({
  contact,
  short,
  tooltip,
  filterText,
}: {
  contact: ContactType
  short?: boolean | null
  tooltip?: string
  filterText?: string
}) {
  const text = getContactText(contact, short)

  if (short && !tooltip) {
    tooltip = getContactText(contact)
  }

  let body
  if (filterText) {
    const ix = text.toLowerCase().indexOf(filterText)
    if (ix < 0) {
      body = text
    } else {
      body = (
        <span>
          {text.substring(0, ix)}
          <ColoredSpan color="white">{text.substring(ix, ix + filterText.length)}</ColoredSpan>
          {text.substring(ix + filterText.length)}
        </span>
      )
    }
  } else {
    body = text
  }

  return <EllipsisSpan title={tooltip}>{body}</EllipsisSpan>
}

export function getContactText(contact: ContactType, short?: boolean | null) {
  const { addressPhone, addressEmail, firstName, lastName } = contact

  const names = []
  if (firstName != null) {
    names.push(firstName)
  }
  if (lastName != null) {
    names.push(short ? lastName.substring(0, 1) : lastName)
  }

  if (names.length > 0) {
    return names.join(' ')
  } else if (addressPhone != null) {
    return formatPhoneNumber(addressPhone)
  } else if (addressEmail != null) {
    return addressEmail
  } else {
    return '(New contact)'
  }
}
